import { render, staticRenderFns } from "./FileInputChallenge.vue?vue&type=template&id=de28aace&scoped=true"
import script from "./FileInputChallenge.vue?vue&type=script&lang=js"
export * from "./FileInputChallenge.vue?vue&type=script&lang=js"
import style0 from "./FileInputChallenge.vue?vue&type=style&index=0&id=de28aace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de28aace",
  null
  
)

export default component.exports